import React from 'react';
import styled from 'styled-components';
import Title from '../Components/Title';
import certificates from '../Data/certificates';
import { MainLayout, InnerLayout } from '../styles/Layouts';
import Particle from '../Components/Particle';

function CertificatesPage() {
  return (
    <MainLayout>
      <CertificatesStyled>
        <Particle />
        <Title title={'Certificates'} span={'Certificates'} />
        <InnerLayout className={'certificate'}>
          {certificates.map((certificate) => {
            const { id, title, date, image, text } = certificate;
            return (
              <div key={id} className={'certificate-item'}>
                <div className="image">
                  <Particle />
                  <img src={image} alt="" />
                </div>

                <div className="title">
                  <h2>{title}</h2>
                  <p className="date">{date}</p>
                  <p className="text">{text}</p>
                </div>
              </div>
            );
          })}
        </InnerLayout>
      </CertificatesStyled>
    </MainLayout>
  );
}

const CertificatesStyled = styled.div`
  .certificate {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 2rem;
    grid-row-gap: 3rem;

    @media screen and (max-width: 770px) {
      grid-template-columns: repeat(1, 1fr);
    }
    .certificate-item {
      background-color: var(--background-dark-grey);
      padding: 1rem 1rem;
      border-radius: 10px;
    }
    .image {
      width: 100%;
      overflow: hidden;
      padding-bottom: 0.5rem;
      img {
        width: 100%;
        height: 50vh;
        object-fit: cover;
        transition: all 0.4s ease-in-out;
        &:hover {
          transform: rotate(3deg) scale(1.1);
        }
      }
    }

    .title {
      h2 {
        font-size: 1.8rem;
      }
      .date {
        font-size: 0.8rem;
        color: var(--white-color);
        transition: all 0.4s ease-in-out;
      }
      .text {
        font-size: 1rem;
        padding: 1rem 0;
        transition: all 0.4s ease-in-out;
      }
    }
  }
`;

export default CertificatesPage;
